/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uHelp = A4uHelp;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4uHelp(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M18,2A16,16,0,1,0,34,18,16,16,0,0,0,18,2Zm.047,26.876a2.69,2.69,0,1,1,0-5.375,2.62,2.62,0,0,1,2.8,2.67A2.581,2.581,0,0,1,18.047,28.876Zm3.566-12.818-.2.21c-.789.829-1.684,1.768-1.684,2.351a2.771,2.771,0,0,0,.359,1.348l.145.277-.113.429a.617.617,0,0,1-.567.378H16.871a.867.867,0,0,1-.65-.235,4.111,4.111,0,0,1-.845-2.525c0-1.677.934-2.714,2.225-4.15.2-.219.39-.42.575-.609.629-.651,1.013-1.071,1.013-1.515,0-.308,0-1.245-1.786-1.245a5.918,5.918,0,0,0-3.159.919.592.592,0,0,1-.653-.02l-.237-.169-.055-.443v-2.9a.879.879,0,0,1,.393-.819,8.275,8.275,0,0,1,4.3-1.1c3.291,0,5.5,2.117,5.5,5.272A6.131,6.131,0,0,1,21.613,16.058Z"
  }));
}